import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ChangeDetectorRef,
  QueryList,
  ViewChildren,
  OnDestroy
} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ReportsService} from "../../reports.service";
import {CurrentRouteService} from "../../../currentRoute.service";
import {AccountIdService, AgencyIdService} from "../../../account.service";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {environment} from '../../../../environments/environment';
import * as _moment from 'moment';
import * as _ from "lodash";
import {MatTableDataSource} from "@angular/material/table";
import {CampaignIdInterfaceData} from "../../../shared/models/adwords.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatAccordion} from "@angular/material/expansion";
import {interval} from "rxjs";

const moment = _moment;

export interface CalendlyInterfaceData {
  date: string,
  provider: string,
  emailaddress: string,
  fullname: string,
  phonenumberstandard: string
}

export interface FormInterfaceData {
  date: string,
  provider: string,
  emailaddress: string,
  fullname: string,
  phonenumberstandard: string
}

export interface EmailInterfaceData {
  date: string,
  provider: string,
  emailaddress: string
}

export interface ClickfunnelInterfaceData {
  date: string,
  emailaddress: string,
  fullname: string,
  phonenumberstandard: string,
  country: string,
  chargedescription: string,
  chargeamount: number,
  last_status: string,
}

export interface JourneyInterfaceData {
  date: string,
  actionid: string,
  provider: string
}


@Component({
  selector: 'app-report-actions',
  templateUrl: './report-actions.component.html',
  styleUrls: ['./report-actions.component.css']
})
export class ReportActionsComponent implements OnInit, AfterViewInit, OnDestroy {

  agency_id: string;
  account_id: string;
  start_date: any;
  end_date: any;
  myForm: UntypedFormGroup;
  is_loading = false;
  is_data = false;
  is_data_loaded = false;
  is_journey_data_loaded = false;




  @ViewChildren(MatAccordion) accordion = new QueryList<MatPaginator>();


  is_table_column_hidden: boolean = true;
  displayedColumns: string[] = ['dt_utc', 'provider', 'emailAddress', 'phoneNumberStandard', 'fullname'];
  dataSource: MatTableDataSource<CalendlyInterfaceData>;

  displayedColumnsClickfunnel: string[] = ['dt_utc', 'emailAddress', 'phoneNumberStandard', 'fullname', 'country', 'chargeDescription', 'charge_amount', 'last_status'];
  dataSourceClickfunnel: MatTableDataSource<ClickfunnelInterfaceData>;

  displayedColumnsJourney: string[] = ['dt_utc', 'actionID', 'provider'];
  dataSourceJourney: MatTableDataSource<JourneyInterfaceData>;

  //https://stackoverflow.com/questions/50428605/multiple-material-pagination-in-one-component-doesnt-work-in-angular
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();


  constructor(
    private cdr: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private reportService: ReportsService,
    private currentrouteService: CurrentRouteService,
    private agencyidService: AgencyIdService,
    private accountidService: AccountIdService,) {
  }

  ngOnInit(): void {

    this.myForm = this.fb.group({
      start_date: [, Validators.required],
      end_date: [, Validators.required],
    })//end myForm

    this.route.params.subscribe(parms => {
      this.account_id = parms['account_id']
      //this.loadData(this.account_id)
      console.log('report campaign performance', this.account_id)
    });

    let query_parms = this.route.snapshot.queryParamMap;
    //this.network = query_parms.get('network');
  } //end ngOnInit

  ngOnDestroy(): void {
    this.stopRunning()
  }

  stopRunning(){

    if (this.auidService) {
      this.auidService.unsubscribe();
    }
    if (this.polling_subscription){
      this.polling_subscription.unsubscribe();
    }
    if (this.loadPresignedUrlService){
      this.loadPresignedUrlService.unsubscribe();
    }
    if (this.getPollEndpointService){
      this.getPollEndpointService.unsubscribe();
    }
    if (this.loadDataService){
      this.loadDataService.unsubscribe();
    }


    this.is_loading = false;
    this.is_running = false;

  }

  xbody = [];
  call_list = [];
  email_list = [];
  form_list = [];
  clickfunnels_list = [];
  journey_list = [];

  is_running = false;  //used for submit form

  polling_subscription: any;
  pollUntillCompleted(report_id) {
    this.polling_subscription = interval(5000).subscribe(x => {
      console.log('pollUntillCompleted', x)
      this.getPollEndpoint(report_id)
    })
  } //pollUntillCompleted(report_id)

  getPollEndpointService: any;
  getPollEndpoint(report_id){

    this.is_loading = true;

    let endpoint = `reports?rt=poller&report_id=${report_id}`;
    this.getPollEndpointService = this.reportService.get(endpoint).subscribe(x => {
      console.log('getPollEndpoint WOWdd', x)
        let poll_status = x['body']['status']
        console.log('STATUS!!!!!!!!!!!!',poll_status)
        if (poll_status != 'pending'){
          this.polling_subscription.unsubscribe();
          if (_.isEmpty(x['body'])) {

          } else {
            let url = x['body']['psurl']
            this.loadPresignedUrl (url)
            this.polling_subscription.unsubscribe();
          } //end isEmpty
        } //end if !pending

      }, error => {

        this.polling_subscription.unsubscribe();
      }
    )


  } // end getPollEndpoint(report_id)

  auidService:any;
  loadDataAuid(auid, start, end) {

    this.is_journey_data_loaded = false;
    this.journey_list = [];
    this.is_loading = true;
    let endpoint = `reports?rt=journey&account_id=${this.account_id}&start_date=${this.start_date}&end_date=${this.end_date}&auid=${auid}`;
    this.auidService = this.reportService.get(endpoint).subscribe(x => {
      if (_.isEmpty(x['body'])) {
        this.is_journey_data_loaded = true;
        this.is_loading = false;
      } else {
        let keys = Object.keys(x['body'])
        for (var _i = 0; _i < keys.length; _i++) {
          this.journey_list.push(x['body'][_i])
          console.log('----------',x['body'][_i]['dt_utc'],x['body'][_i]['actionID'],x['body'][_i]['provider'])
        } //end for
      } //end if else


      this.dataSourceJourney = new MatTableDataSource(this.journey_list);
      this.cdr.detectChanges();
      this.dataSourceJourney.paginator = this.paginator.toArray()[2];
      this.dataSourceJourney.sort = this.sort.toArray()[2];
      this.is_journey_data_loaded = true;
      this.is_loading = false;
      console.log('wow',this.journey_list.length,this.is_journey_data_loaded)
    }) //end fu

    } //end LoadDataAuid

   populateTables(x){

     this.is_data_loaded = false;
     if (_.isEmpty(x['body'])) {
       this.is_data = true;
       this.is_loading = false;
       this.is_running = false;
     } else {
       let keys = Object.keys(x['body'])
       for (var _i = 0; _i < keys.length; _i++) {

         if (x['body'][_i]['provider'] == 'calendy') {
           this.call_list.push(x['body'][_i])
         }
         if (x['body'][_i]['provider'] == 'email') {
           let ff = x['body'][_i];
           ff['emailAddress'] = ff['invitee_email'];
           ff['fullname'] = ff['invitee_full_name']
           if (ff['invitee_email']) {
             this.call_list.push(ff)
           }
         }
         if (x['body'][_i]['provider'] == 'form') {
           this.form_list.push(x['body'][_i])
           this.call_list.push(x['body'][_i])
         }
         if (x['body'][_i]['provider'] == 'clickfunnels') {
           this.clickfunnels_list.push(x['body'][_i])
         }
       } //end loop

       this.dataSource = new MatTableDataSource(this.call_list);
       this.cdr.detectChanges();
       this.dataSourceClickfunnel = new MatTableDataSource(this.clickfunnels_list);
       this.cdr.detectChanges();
       //https://stackoverflow.com/questions/50428605/multiple-material-pagination-in-one-component-doesnt-work-in-angular
       this.dataSource.paginator = this.paginator.toArray()[0];
       this.dataSource.sort = this.sort.toArray()[0];
       this.dataSourceClickfunnel.paginator = this.paginator.toArray()[1];
       this.dataSourceClickfunnel.sort = this.sort.toArray()[1];


       this.is_data_loaded = true;
       this.is_loading = false;
       this.is_running = false;
     }

   }

  loadPresignedUrlService: any;
  loadPresignedUrl (url) {


    this.is_loading = true;
    let endpoint = '';
    endpoint = url;
    this.is_data = false;
    this.loadPresignedUrlService = this.reportService.get_psurl(endpoint).subscribe(x => {


      this.is_data_loaded = false;
      if (_.isEmpty(x['body'])) {
        this.is_data = true;
        this.is_loading = false;
        this.is_running = false;
      } else {
        let keys = Object.keys(x['body'])
        for (var _i = 0; _i < keys.length; _i++) {

          if (x['body'][_i]['provider'] == 'calendy') {
            this.call_list.push(x['body'][_i])
          }
          if (x['body'][_i]['provider'] == 'email') {
            let ff = x['body'][_i];
            ff['emailAddress'] = ff['invitee_email'];
            ff['fullname'] = ff['invitee_full_name']
            if (ff['invitee_email']) {
              this.call_list.push(ff)
            }
          }
          if (x['body'][_i]['provider'] == 'form') {
            this.form_list.push(x['body'][_i])
            this.call_list.push(x['body'][_i])
          }
          if (x['body'][_i]['provider'] == 'clickfunnels') {
            this.clickfunnels_list.push(x['body'][_i])
          }
        } //end loop

        this.dataSource = new MatTableDataSource(this.call_list);
        this.cdr.detectChanges();
        this.dataSourceClickfunnel = new MatTableDataSource(this.clickfunnels_list);
        this.cdr.detectChanges();
        //https://stackoverflow.com/questions/50428605/multiple-material-pagination-in-one-component-doesnt-work-in-angular
        this.dataSource.paginator = this.paginator.toArray()[0];
        this.dataSource.sort = this.sort.toArray()[0];
        this.dataSourceClickfunnel.paginator = this.paginator.toArray()[1];
        this.dataSourceClickfunnel.sort = this.sort.toArray()[1];


        this.is_data_loaded = true;
        this.is_loading = false;
        this.is_running = false;
      }


    }, error => {
      //console.log('ERROR@@@@@@@@@@@@@@@@@@@@ ',error)
      this.is_loading = false;
      this.is_data = true;
      this.is_running = false;
    }); //end apiService

  } //end loadPresignedUrl

  loadDataService: any;
  loadData(start, end) {
    this.is_loading = true;
    let endpoint = '';
    endpoint = `reports?rt=actions&account_id=${this.account_id}&start_date=${start}&end_date=${end}&worker=true&psurl=true`;
    this.is_data = false;
    this.loadDataService = this.reportService.get(endpoint).subscribe(x => {

      // this.is_data_loaded = false;
      // console.log('loadData',x['body']['psurl'])
      // let psurl = x['body']['psurl'];
      // this.loadPresignedUrl(psurl);

      if (environment['environment']=='local'){
        //console.log(x['body'])
        this.populateTables(x)
      } else{
        console.log('getPollEndpoing!!!!!!!!!!!!!!!!!!!!!!!', x['body']['status'])
        let report_id = x['body']['report_id']
        this.pollUntillCompleted(report_id)
      }




    }, error => {
      //console.log('ERROR@@@@@@@@@@@@@@@@@@@@ ',error)
      this.is_loading = false;
      this.is_data = true;
    }); //end apiService

  } //end loadData

  ngAfterViewInit(): void {

  }

  is_open = false;
  accClosed(){
   // this.accordion.toArray()[0];


    this.is_open = false;
    console.log('closed')
  }

  accOpened(){
    this.is_open = true;
    console.log('opened')
  }

  addDateEvent(type, event) {
    console.log(type, event.value)
    this.is_data = false;

  } //end addDateEvent

  is_auid_view = false;
  getTableRecord(row) {
    console.log('GET JOURNEY',row)
    let auid = row['auid'];
    this.is_auid_view = true;
    this.loadDataAuid(auid, this.start_date, this.end_date)

  } // end getTableRecord( )

  goBack(){
    this.is_auid_view = false;
  }

  // dataSource is a parameter here
  applyFilterMulti(event: Event, dataSource: any) {
    //applyFilter($event, table.dataSource)
    //https://stackoverflow.com/questions/62540355/how-to-add-multiple-tables-each-having-filter-sort-pagination-in-angular-mater
    //USE THE ABOVE TO CREATE A SINGLE FILTER PER DATASORUCE
    const filterValue = (event.target as HTMLInputElement).value;
    dataSource.filter = filterValue.trim().toLowerCase();
    if (dataSource.paginator) {
      dataSource.paginator.firstPage();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } // applyFilter

  applyFilterSales(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceClickfunnel.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceClickfunnel.paginator) {
      this.dataSourceClickfunnel.paginator.firstPage();
    }
  } // applyFilter

  applyFilterJourney(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceJourney.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceJourney.paginator) {
      this.dataSourceJourney.paginator.firstPage();
    }
  } // applyFilter

  onSubmit() {

    //this.timeseries_list = []

    this.is_running = true;
    this.is_data = false;

    this.clickfunnels_list = []
    this.call_list = []
    this.is_data_loaded = false;

    let start_date = this.myForm.value['start_date']
    start_date = moment(start_date);
    start_date = start_date.format('YYYY-MM-DD');

    let end_date = this.myForm.value['end_date']
    end_date = moment(end_date);
    end_date = end_date.format('YYYY-MM-DD');

    this.start_date = start_date;
    this.end_date = end_date;

    console.log('FFFFFFFFFFFFFFFFFFFF',start_date, end_date)

    this.loadData(start_date, end_date)
  } //end onSubmit

} //end class
